// Re-exports from unified color system
import { useMemo } from 'react';
import { PRIMITIVE_COLORS } from '../residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const PAYMENT_COLORS = {
  SUCCESS_GREEN: PRIMITIVE_COLORS.successGreenBright,
  SUCCESS_GREEN_LIGHT: PRIMITIVE_COLORS.successGreenLight,
  ERROR_RED: PRIMITIVE_COLORS.resioRed,
  WARNING_ORANGE: PRIMITIVE_COLORS.warningYellow,
  WHITE: PRIMITIVE_COLORS.white,
  GRAY_LIGHT: PRIMITIVE_COLORS.gray100,
  GRAY_MEDIUM: '#E5E5EA',
  BLUE_LIGHT: '#EBF4FF',
  TEXT_PRIMARY: PRIMITIVE_COLORS.black,
  TEXT_SECONDARY: PRIMITIVE_COLORS.white,
  TEXT_TERTIARY: '#8E8E93',
} as const;

export function usePaymentColors() {
  const { semantic, components, colors } = useThemeColors();
  return useMemo(() => ({
    SUCCESS_GREEN: semantic.status.success,
    SUCCESS_GREEN_LIGHT: semantic.status.successBg,
    ERROR_RED: semantic.status.error,
    WARNING_ORANGE: semantic.status.warning,
    WHITE: colors.text.primary,
    GRAY_LIGHT: colors.text.tertiary,
    GRAY_MEDIUM: colors.text.secondary,
    BLUE_LIGHT: colors.accent.blueBgLight,
    TEXT_PRIMARY: semantic.text.primary,
    TEXT_SECONDARY: semantic.text.secondary,
    TEXT_TERTIARY: semantic.text.muted,
  }), [semantic, components, colors]);
}
